import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {AuthGuard} from './guards/index';
import {ChangeGuard } from './guards/change.guard';

// Import Containers
import {
    FullLayoutComponent,
    SimpleLayoutComponent,
    TabLayoutComponent
} from './containers';
import {RefundsModule} from "./views/pro/refund/refund.module";


export const routes: Routes = [
    {
        path: '',
        redirectTo: 'pages/login',
        pathMatch: 'full',

    },
    {
        path: '',
        component: FullLayoutComponent,
        data: {
            title: 'Home'
        }, canActivate: [AuthGuard],
        children: [
            {
                path: 'base',
                loadChildren: './views/base/base.module#BaseModule'
            },
            {
                path: 'buttons',
                loadChildren: './views/buttons/buttons.module#ButtonsModule'
            },
            {
                path: 'charts',
                loadChildren: './views/chartjs/chartjs.module#ChartJSModule'
            },
            {
                path: 'dashboard',
                loadChildren: './views/dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'mainsystem',
                loadChildren: './views/mainsystem/mainsystem.module#MainsystemModule'
            },
            {
                path: 'icons',
                loadChildren: './views/icons/icons.module#IconsModule'
            },
            {
                path: 'notifications',
                loadChildren: './views/notifications/notifications.module#NotificationsModule'
            },
            {
                path: 'theme',
                loadChildren: './views/theme/theme.module#ThemeModule'
            },
            {
                path: 'widgets',
                loadChildren: './views/widgets/widgets.module#WidgetsModule'
            }
        ]
    },
    {
        path: '',
        component: TabLayoutComponent,
        data: {
            title: 'Home'
        }, canActivate: [AuthGuard],
        children: [
            {
                path: 'permission',
                loadChildren: './views/permission/permission.module#PermissionModule'
            }
        ]
    },
    {
        path: 'users',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/users/users.module#UsersModule'
            }
        ]
    },
    {
        path: 'stores',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/stores/stores.module#StoresModule'
            }
        ]
    },
    {
        path: 'branches',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/branches/branches.module#BranchesModule'
            }
        ]
    },
    {
        path: 'members',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/members/members.module#MembersModule'
            }
        ]
    },
    {
        path: 'departments',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/departments/departments.module#DepartmentsModule'
            }
        ]
    },
    {
        path: 'classifications',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/classifications/classifications.module#ClassificationsModule'
            }
        ]
    },
    {
        path: 'processes',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/management/processes/processes.module#ProcessesModule'
            }
        ]
    },
    {
        path: 'archive',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/archive/archive.module#ArchiveModule'
            }
        ]
    },
    {
        path: 'taxes',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/taxes/taxes.module#TaxesModule'
            }
        ]
    },
    {
        path: 'customers',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/customers/customers.module#CustomersModule'
            }
        ]
    },
    {
        path: 'branches_settings',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/branches_settings/branches_settings.module#BranchesSettingsModule'
            }
        ]
    },
    {
        path: 'suppliers',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/suppliers/suppliers.module#SuppliersModule'
            }
        ]
    },
    {
        path: 'fields',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/fields/fields.module#FieldsModule'
            }
        ]
    },
    {
        path: 'employees',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/employees/employees.module#EmployeesModule'
            }
        ]
    },
    {
        path: 'permissions',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/permissions/permissions.module#PermissionsModule'
            }
        ]
    },
    {
        path: 'roles',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/permissions/permissions.module#PermissionsModule'
            }
        ]
    },
  {
    path: 'currencies',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/setting/currencies/currencies.module#CurrenciesModule'
      }
    ]
  },
  {
    path: 'banks',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/setting/banks/banks.module#BanksModule'
      }
    ]
  },
    {
        path: 'years',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/years/years.module#YearsModule'
            }
        ]
    },
    {
        path: 'organization',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/organization/organization.module#OrganizationModule'
            }
        ]
    },
    {
        path: 'cities',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/cities/cities.module#CitiesModule'
            }
        ]
    },  {
        path: 'itemsGroups',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/itemsGroups/itemsGroups.module#ItemsGroupsModule'
            }
        ]
    }
  ,  {
    path: 'items_groups',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/setting/itemsGroups/itemsGroups.module#ItemsGroupsModule'
      }
    ]
  }, {
        path: 'items',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/items/items.module#ItemsModule'
            }
        ]
    },
    {
        path: 'jobs',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/setting/jobs/jobs.module#JobsModule'
            }
        ]
    },
	{
        path: 'tasks',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/management/tasks/tasks.module#TasksModule'
            }
        ]
    },
    {
        path: 'distribution',
        component: FullLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/management/distribution/distribution.module#DistributionModule'
            }
        ]
    },
	{
        path: 'distribution_departments',
        component: FullLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/management/distribution_departments/distribution.module#DistributionModule'
            }
        ]
    },
	{
        path: 'taskpost',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/management/taskpost/taskpost.module#TaskpostModule'
            }
        ]
    },

    {
        path: 'returninvoices',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/pos/returninvoices/returninvoices.module#ReturninvoicesModule',
            }
        ]
    }
  ,

  {
    path: 'invoices',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/pos/invoices/invoices.module#InvoicesModule',
      }
    ]
  },

  {
    path: 'itemlists',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/pos/itemlists/itemlists.module#ItemlistsModule',
      }
    ]
  },
  {
    path: 'accounts',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/fin/accounts/accounts.module#AccountsModule',
      }
    ]
  },
  {
    path: 'accountbranches',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/fin/accountbranches/accountbranches.module#AccountbranchesModule',
      }
    ]
  },
  {
    path: 'costcenters',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/fin/costcenters/costcenters.module#CostcentersModule',
      }
    ]
  },
  {
    path: 'journals',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/fin/journals/journals.module#JournalsModule',
      }
    ]
  },
  {
    path: 'openingbalances',
    component: TabLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/fin/openingbalances/openingbalances.module#OpeningbalancesModule',
      }
    ]
  },
  {
        path: 'reciept_vouchers',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/fin/reciept_vouchers/reciept_vouchers.module#RecieptVouchersModule',
            }
        ]
    },
  {
        path: 'additionals',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/fin/additionals/additionals.module#AdditionalsModule',
            }
        ]
    },
  {
        path: 'account_report',
        component: FullLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/fin/account_report/account_report.module#Account_reportModule',
            }
        ]
    },
  {
        path: 'post_accounts',
        component: FullLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/fin/post_accounts/post_accounts.module#Post_accountsModule',
            }
        ]
    },
    {
        path: 'total_report',
        component: FullLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/fin/total_report/total_report.module#TotalReportModule',
            }
        ]
    },
    {
      path: 'itemstransactions',
      component: FullLayoutComponent,
      canActivateChild: [AuthGuard],
      children: [
        {
          path: '',
          loadChildren: './views/pro/itemstransactions/itemstransactions.module#ItemsTransactionsModule',
        }
      ]
    },
    {
      path: 'itemsquantity',
      component: FullLayoutComponent,
      canActivateChild: [AuthGuard],
      children: [
        {
          path: '',
          loadChildren: './views/pro/itemsquantity/itemsquantity.module#ItemsQuantityModule',
        }
      ]
    },
    {
        path: 'expense_vouchers',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/fin/expense_vouchers/expense_vouchers.module#ExpenseVouchersModule',
            }
        ]
    },

    {
        path: 'pages',
        component: SimpleLayoutComponent,
        data: {
            title: 'Pages'
        },
        children: [
            {
                path: '',
                loadChildren: './views/pages/pages.module#PagesModule',
            }
        ]
    },

    {
        path: 'pos',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/pos/pos.module#PosModule',
            }
        ]
    },
    {
        path: 'purchases',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/pro/purchases/purchases.module#PurchasesModule',
            }
        ]
    },
    {
        path: 'inventory',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/pro/inventory/inventory.module#InventoryModule',
            }
        ]
    },
    {
        path: 'depreciation',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/pro/depreciation/depreciation.module#DepreciationModule',
            }
        ]
    },
    {
        path: 'exchange',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/pro/exchange/exchange.module#ExchangeModule',
            }
        ]
    },
    {
        path: 'refunds',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './views/pro/refunds/refunds.module#RefundsModule',
            }
        ]
    },

    {
        path: 'setting',
        component: TabLayoutComponent,
        canActivateChild: [AuthGuard],

        children: [
            {
                path: '',
                loadChildren: './views/setting/setting.module#SettingModule',
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts